module.exports = __webpack_public_path__ + "img/x_mark_white.cb84f378.svg";